import React from "react";
import { useI18n } from "@/lib/i18n";
import { Modal } from "@/components/gameplay/parts";

/**
 * Shown after a wrong answer when the game has more than 1 life. Resumes
 * the timer + spins to the next round on Continue. The parent owns the
 * resume/animateSpin/round bump.
 */
export default function LivesLostModal({ info, onContinue }) {
  const { t } = useI18n();
  if (!info) return null;
  return (
    <Modal>
      <div className="text-6xl mb-2" aria-hidden>💔</div>
      <h2 className="text-2xl font-[Fredoka] font-extrabold text-rose-600 mb-1" data-testid="lives-modal-title">
        {t("lives_lost_title")}
      </h2>
      <p className="text-slate-700 text-base">
        {t("lives_used")}: <b className="text-rose-700" data-testid="lives-modal-used">{info.used}</b> / <b>{info.total}</b>
        {" "}· {t("lives_remaining")}: <b className="text-emerald-700" data-testid="lives-modal-remaining">{info.total - info.used}</b>
      </p>
      <p className="text-slate-600 text-sm mt-2">
        {t("penalty_applied")}: <b className="text-amber-700" data-testid="lives-modal-penalty">+{info.penalty}s</b>
      </p>
      <button
        data-testid="lives-modal-continue"
        onClick={onContinue}
        className="mt-5 px-6 py-3 bg-sky-500 hover:bg-sky-600 text-white rounded-full font-bold border-b-2 border-sky-700 active:translate-y-[1px] active:border-b-0"
      >
        {t("continue_btn")}
      </button>
    </Modal>
  );
}
